import { __assign, __awaiter, __generator } from "tslib";
import { ActionExecutorEventType, } from '@office-start/action-types';
import { UnreactiveActionCreators } from '@office-start/toast-utility';
export var createNextActionEventHandler = function (nextActionEventEmitter, actionExecutor, actionManager) {
    var onRunNextHandler = function (runNext) { return __awaiter(void 0, void 0, void 0, function () {
        var createErrorNotification, createSuccessNotification, _a, appId, id, actionDefinition, officeContent, executableAction, telemetryConfig;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    createErrorNotification = UnreactiveActionCreators.createErrorNotification, createSuccessNotification = UnreactiveActionCreators.createSuccessNotification;
                    _a = runNext.nextAction, appId = _a.appId, id = _a.id;
                    actionDefinition = actionManager.getActionByAppId(appId, id);
                    officeContent = runNext.payload;
                    if (!officeContent) {
                        if ((_c = (_b = actionDefinition === null || actionDefinition === void 0 ? void 0 : actionDefinition.metadata.notificationOptions) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.message) {
                            createErrorNotification((_e = (_d = actionDefinition === null || actionDefinition === void 0 ? void 0 : actionDefinition.metadata.notificationOptions) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e.message);
                        }
                        return [2 /*return*/];
                    }
                    executableAction = actionDefinition === null || actionDefinition === void 0 ? void 0 : actionDefinition.officeActionCreator(officeContent);
                    // If we can't run the next action, bail out...
                    if (!executableAction || !actionDefinition) {
                        if ((_g = (_f = actionDefinition === null || actionDefinition === void 0 ? void 0 : actionDefinition.metadata.notificationOptions) === null || _f === void 0 ? void 0 : _f.error) === null || _g === void 0 ? void 0 : _g.message) {
                            createErrorNotification((_j = (_h = actionDefinition === null || actionDefinition === void 0 ? void 0 : actionDefinition.metadata.notificationOptions) === null || _h === void 0 ? void 0 : _h.error) === null || _j === void 0 ? void 0 : _j.message);
                        }
                        return [2 /*return*/];
                    }
                    telemetryConfig = {
                        actionId: actionDefinition.metadata.id,
                        appId: actionDefinition.metadata.appId,
                        sourceUXComponent: 'ContentActions',
                        params: {},
                        actionMenuSource: 'ContentActionsNext',
                        referral: executableAction.payload.referral,
                        referralPlatform: executableAction.payload.referralPlatform,
                    };
                    if (!runNext.nextActionNotification) return [3 /*break*/, 1];
                    createSuccessNotification(runNext.nextActionNotification.message, runNext.nextActionNotification.actionText
                        ? {
                            label: runNext.nextActionNotification.actionText,
                            onClick: function () {
                                actionExecutor.executeActionAsync(executableAction, __assign(__assign({}, telemetryConfig), { sourceUXComponent: 'Toast', actionMenuSource: 'ContentActionsToast' }));
                            },
                        }
                        : undefined, runNext.nextActionNotification.link &&
                        runNext.nextActionNotification.link.url
                        ? {
                            label: runNext.nextActionNotification.link.text,
                            url: runNext.nextActionNotification.link.url,
                        }
                        : undefined);
                    return [3 /*break*/, 3];
                case 1: 
                // $TODO: evlave - handle and think about errors
                // Given this architecture (without any state), how do we let the user know their action failed? What can they do about it?
                // We are now in a state where an action has been executed, and the next action has failed. No caller will be notified of this failure
                // at this point.
                // if (result?.error) {
                //     // Hook into error dialog for errors? How does office.com handle unexpected exceptions today?
                //     // Or should we fire the error from the executor itself? Then it will have been handled however that action type wants to handle it.
                // }
                return [4 /*yield*/, actionExecutor.executeActionAsync(executableAction, telemetryConfig)];
                case 2:
                    // $TODO: evlave - handle and think about errors
                    // Given this architecture (without any state), how do we let the user know their action failed? What can they do about it?
                    // We are now in a state where an action has been executed, and the next action has failed. No caller will be notified of this failure
                    // at this point.
                    // if (result?.error) {
                    //     // Hook into error dialog for errors? How does office.com handle unexpected exceptions today?
                    //     // Or should we fire the error from the executor itself? Then it will have been handled however that action type wants to handle it.
                    // }
                    _k.sent();
                    _k.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // Register the listeners
    nextActionEventEmitter.on(ActionExecutorEventType.RunNext, onRunNextHandler);
    // Someday, unsubscribe ?
    // nextActionEventEmitter.removeListener(ActionExecutorNextActionEventType.RunNext, onRunNextHandler);
};
//# sourceMappingURL=nextActionEventHandler.js.map